<script lang="ts">
    import type {MessageBasicGroupChatCreate} from "./Types";
    export let entity: MessageBasicGroupChatCreate
</script>
<div class="alert alert-primary m-0">
    Створення групового чату "{entity.title}" для користувачів tg: {entity.member_user_ids.join(', ')}
</div>
